export class CHeliPlayer {
  protected readonly playerId: string;
  protected readonly userCode: string | null;
  protected readonly role: string | null;
  protected readonly rtcUserCode: number | null;
  protected readonly channelSessionCode: string | null;

  // 音量
  mute: boolean = false;

  // 画面共有
  screenSharing: boolean = false;

  // 高頻度同期
  fullAvatarState: boolean = true;
  motionTrackingState: boolean = false;

  constructor({
    playerId,
    userCode,
    role,
    rtcUserCode,
    channelSessionCode
  }: {
    playerId: string;
    userCode: string | null;
    role: string | null;
    rtcUserCode: number | null;
    channelSessionCode: string | null;
  }) {
    this.playerId = playerId;
    this.userCode = userCode;
    this.role = role;
    this.rtcUserCode = rtcUserCode;
    this.channelSessionCode = channelSessionCode;
  }

  getPlayerId(): string {
    return this.playerId;
  }
  getRtcUserCode(): number | null {
    return this.rtcUserCode;
  }
  getRole(): string | null {
    return this.role;
  }
  getChannelSessionCode(): string | null {
    return this.channelSessionCode;
  }
}
